import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getContent } from "@/lib/api";
import { Icon } from "@/components/icons";
import { Reveal } from "@/components/primitives";

export function StrategyCard({ s, index }) {
  return (
    <Reveal delay={index * 0.06}>
      <div
        data-testid={`strategy-card-${s.slug}`}
        className="group relative h-full rounded-xl border border-white/10 bg-[#0A0B10] p-6 md:p-7 overflow-hidden transition-colors hover:border-[#2DD4BF]/40"
      >
        <div
          className="pointer-events-none absolute -inset-px rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          style={{ background: "radial-gradient(400px circle at var(--x,50%) var(--y,0%), rgba(45,212,191,0.08), transparent 60%)" }}
        />
        <div className="relative flex items-start justify-between mb-6">
          <span className="font-mono text-xs text-[#0E9E90] tracking-widest">{s.code}</span>
          <span className="grid place-items-center h-11 w-11 rounded-lg border border-white/10 bg-white/[0.03] text-[#2DD4BF] group-hover:scale-110 group-hover:border-[#2DD4BF]/40 transition-all duration-300">
            <Icon name={s.icon} size={22} weight="duotone" />
          </span>
        </div>
        <h3 className="relative text-lg font-bold text-white mb-3">{s.title}</h3>
        <p className="relative text-sm text-[#94A3B8] leading-relaxed mb-6">{s.summary}</p>
        <div className="relative rounded-lg border border-white/10 bg-black/30 px-3 py-2.5">
          <p className="font-mono text-[11px] text-[#2DD4BF]/90 truncate">{s.visual}</p>
        </div>
      </div>
    </Reveal>
  );
}

export function StrategiesGrid() {
  const [strategies, setStrategies] = useState([]);
  useEffect(() => {
    getContent("strategies").then(setStrategies).catch(() => {});
  }, []);
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
      onMouseMove={(e) => {
        const t = e.target.closest("[data-testid^='strategy-card']");
        if (t) {
          const r = t.getBoundingClientRect();
          t.style.setProperty("--x", `${e.clientX - r.left}px`);
          t.style.setProperty("--y", `${e.clientY - r.top}px`);
        }
      }}
      data-testid="strategies-grid"
    >
      {strategies.map((s, i) => (
        <StrategyCard key={s.id} s={s} index={i} />
      ))}
    </div>
  );
}
